import VueI18n from 'vue-i18n';
import Vue from 'vue';
// import locale from 'element-ui/lib/locale'
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from 'element-ui/lib/locale/lang/en'
import cn from './languages/cn'
import en from './languages/en'


Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'cn',
  messages: {
    en:{
      ...en,
      ...enLocale
    },
    cn:{
      ...cn,
      ...zhLocale
    }
  },
  silentTranslationWarn: true,
});

export default i18n;